import moment from 'moment';

// For a column that doesn't have custom object values
export const generateFiltersForGenericColumn = (dataSource, columnName, alphabetized = true) => {
  let uniqueDataSource = [...new Set(dataSource.map((row) => row[columnName]))];

  if (alphabetized) {
    uniqueDataSource = uniqueDataSource.sort();
  }

  return uniqueDataSource.map((value) => ({
    text: value,
    value,
  }));
};

export const onFilterGenericColumn = (value, record, columnName) => {
  return record[columnName] === value;
};

// Applicant has a custom object with { name, email }, so it needs a special generator.
export const generateFiltersForApplicants = (dataSource) => {
  const uniqueAlphabetizedNames = [...new Set(dataSource.map((row) => row.applicants.name))].sort();

  return uniqueAlphabetizedNames.map((name) => ({
    text: name,
    value: name,
  }));
};
export const onFilterApplicants = (value, record) => record.applicants.name.indexOf(value) === 0;

// LastContacted is a date, so it needs a special generator.
export const generateFiltersForDateFromNow = (dataSource, columnName) => {
  const dates = dataSource.map((row) => row[columnName]);

  let uniqueDates = [];

  dates.forEach((date) => {
    if (
      !uniqueDates
        .map((uniqueDate) => moment(uniqueDate).fromNow())
        .includes(moment(date).fromNow())
    ) {
      uniqueDates.push(date);
    }
  });

  uniqueDates = uniqueDates.sort((a, b) => moment(b).diff(a));

  return uniqueDates.map((date) => ({
    text: moment(date).fromNow(),
    value: date,
  }));
};

export const onFilterDateFromNow = (value, record, columnName) => {
  return moment(record[columnName]).fromNow() === moment(value).fromNow();
};
